import * as ng from 'angular';
import * as Linq from 'linq-es5';
import { IToastMessageService } from '../../../services';
import { Dto } from '../../../data';
import { IFrequentParkerAccountSummaryResource } from '../';
import { Moment } from 'moment';

let FrequentParkerAccountSummaryServiceFactory: Function =
    function ($q: ng.IQService,
        FrequentParkerAccountSummary: IFrequentParkerAccountSummaryResource,
        toastMessageFactory: IToastMessageService,
        moment: Moment): IFrequentParkerAccountSummaryService {
        return new FrequentParkerAccountSummaryService($q, FrequentParkerAccountSummary, toastMessageFactory, moment);
    }

FrequentParkerAccountSummaryServiceFactory.$inject = ['$q', 'FrequentParkerAccountSummary', 'toastMessageFactory', 'moment'];

let FrequentParkerAccountSummaryServices = {
    name: "FrequentParkerAccountSummaryService",
    factory: FrequentParkerAccountSummaryServiceFactory
};

interface IFrequentParkerAccountSummaryService {
    getFpaSummary(): ng.IPromise<Dto.IFrequentParkerAccountSummary>;
}

export class FrequentParkerAccountSummaryService implements IFrequentParkerAccountSummaryService {

    constructor(private $q: ng.IQService,
        private FrequentParkerAccountSummary: IFrequentParkerAccountSummaryResource,
        private toastMessageFactory: IToastMessageService,
        private moment: Moment) {
        console.log('FrequentParkerAccountSummaryService loading');
        //activate service
        this.activate();
    }

    //functions
    public activate(): void {
        console.log('FrequentParkerAccountSummaryService loaded');
    }

    private getPointsRequests(): Array<Dto.IDashboardKpiRequest> {
        return [
            {
                startDate: (this.moment as any)().startOf('month').toISOString(),
                endDate: (this.moment as any)().endOf('month').toISOString(),
                key: Dto.DateRanges.CurrentMonth
            },
            {
                startDate: (this.moment as any)().add(-1, 'M').startOf('month').toISOString(),
                endDate: (this.moment as any)().add(-1, 'M').endOf('month').toISOString(),
                key: Dto.DateRanges.LastMonth
            },
            {
                startDate: (this.moment as any)().startOf('year').toISOString(),
                endDate: (this.moment as any)().endOf('year').toISOString(),
                key: Dto.DateRanges.CurrentYear
            },
            {
                startDate: (this.moment as any)().add(-1, 'Y').startOf('year').toISOString(),
                endDate: (this.moment as any)().add(-1, 'Y').endOf('year').toISOString(),
                key: Dto.DateRanges.LastYear
            },
            {
                startDate: undefined,
                endDate: undefined,
                key: Dto.DateRanges.All
            }];
    }

    public getFpaSummary(): ng.IPromise<Dto.IFrequentParkerAccountSummary> {

        let awardedPromise = this.FrequentParkerAccountSummary
            .getKpi({ kpi: Dto.DashboardKPIs.PointsAwarded }, this.getPointsRequests()).$promise;

        let redeemedPromise = this.FrequentParkerAccountSummary
            .getKpi({ kpi: Dto.DashboardKPIs.PointsRedeemed }, this.getPointsRequests()).$promise;

        let signUpPromise = this.FrequentParkerAccountSummary
            .getKpi({ kpi: Dto.DashboardKPIs.SignUp }, this.getPointsRequests()).$promise;

        let fpAccountPromise = this.FrequentParkerAccountSummary
            .getKpi({ kpi: Dto.DashboardKPIs.ActiveInactive }, this.getPointsRequests()).$promise;

        return this.$q.all([awardedPromise, redeemedPromise, signUpPromise, fpAccountPromise
        ])
            .then(([awardedResponse, redeemedResponse, signUpResponse, fpAccountResponse
            ]) => {
                let awardedDict = Linq.From(awardedResponse as Array<Dto.IDashboardKpiResponse>)
                    .ToDictionary(x => x.key.toString(), x => x as Dto.IDashboardPointKpiResponse);

                let redeemedDict = Linq.From(redeemedResponse as Array<Dto.IDashboardKpiResponse>)
                    .ToDictionary(x => x.key.toString(), x => x as Dto.IDashboardPointKpiResponse);

                let signUpDict = Linq.From(signUpResponse as Array<Dto.IDashboardKpiResponse>)
                    .ToDictionary(x => x.key.toString(), x => x as Dto.IDashboardCountKpiResponse);

                let fpAccountDict = Linq.From(fpAccountResponse as Array<Dto.IDashboardKpiResponse>)
                    .ToDictionary(x => x.key.toString(), x => x as Dto.IDashboardActiveInactiveKpiResponse);
                
                return this.$q.resolve({
                    totalAccounts: fpAccountDict.get(Dto.DateRanges.All.toString()),
                    currentMonthAwarded: awardedDict.get(Dto.DateRanges.CurrentMonth.toString()),
                    lastMonthAwarded: awardedDict.get(Dto.DateRanges.LastMonth.toString()),
                    currentYearAwarded: awardedDict.get(Dto.DateRanges.CurrentYear.toString()),
                    lastYearAwarded: awardedDict.get(Dto.DateRanges.LastYear.toString()),
                    signUpCurrentMonth: signUpDict.get(Dto.DateRanges.CurrentMonth.toString()),
                    signUpLastMonth: signUpDict.get(Dto.DateRanges.LastMonth.toString()),
                    signUpCurrentYear: signUpDict.get(Dto.DateRanges.CurrentYear.toString()),
                    signUpLastYear: signUpDict.get(Dto.DateRanges.LastYear.toString()),
                    currentMonthRedeemed: redeemedDict.get(Dto.DateRanges.CurrentMonth.toString()),
                    lastMonthRedeemed: redeemedDict.get(Dto.DateRanges.LastMonth.toString()),
                    currentYearRedeemed: redeemedDict.get(Dto.DateRanges.CurrentYear.toString()),
                    lastYearRedeemed: redeemedDict.get(Dto.DateRanges.LastYear.toString())
                } as Dto.IFrequentParkerAccountSummary);
            });

    }
}

export { FrequentParkerAccountSummaryServices, IFrequentParkerAccountSummaryService };
export default FrequentParkerAccountSummaryServices;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/services/frequent-parker-account-summary-service.ts